import gql from "graphql-tag";

export const projectsQuery = gql`
  query projects(
    $products: [ID]
    $instances: [ID]
    $countries: [ID]
    $authorizations: [ID]
    $marketSegments: [String]
    $lang: String
    $keyword: String
    $afterCursor: String
    $beforeCursor: String
    $first: Int
  ) {
    promotedProjects(
      products: $products
      instances: $instances
      countries: $countries
      authorizations: $authorizations
      marketSegments: $marketSegments
      lang: $lang
      keyword: $keyword
      after: $afterCursor
      before: $beforeCursor
      first: $first
    ) {
      edges {
        node {
          id
          slug
          title
          image
          marketSegment
          country {
            id
            name
          }
          city {
            id
            name
          }
          products {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
`;
